import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { Grid } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useEffect } from 'react';
import { ContasPagarUtil } from '../store/contasPagarAction';

const getValorPago = (values) => {
  const acrescimoDesconto =
    (values?.baixa?.juros?.valor || 0) + (values?.baixa?.multa?.valor || 0) - (values?.baixa?.desconto?.valor || 0) ||
    0;

  return isNaN(values?.baixa?.valorPago + acrescimoDesconto)
    ? '-'
    : getCurrency(values?.baixa?.valorPago + acrescimoDesconto);
};

const ContasPagarAcrescimosDescontos = ({ values, handleChange, handleBlur, disabled }) => {
  const juros = values?.baixa?.juros;
  const multa = values?.baixa?.multa;
  const desconto = values?.baixa?.desconto;
  const jurosValor = juros?.valor;
  const multaValor = multa?.valor;
  const descontoValor = desconto?.valor;
  useEffect(() => {
    if (values.categorias) {
      let valorLiquido;
      if (values.numeroParcelas > 1) {
        const { parcela, parcelamento } = values;
        const { parcelas } = parcelamento;

        valorLiquido = parcelas[parcela || 0]?.valorLiquido;
      } else {
        valorLiquido = ContasPagarUtil.calcularValorTotalLiquido(values);
      }
      const valorPago = valorLiquido + (jurosValor || 0) + (multaValor || 0) - (descontoValor || 0);

      handleChange({ target: { id: 'valorPago', value: valorPago } });
    }
    // Memoização intencional: as funções/props são recriadas a cada render e incluí-las
    // anularia o memo; o estado que elas leem já está nas dependências.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jurosValor, multaValor, descontoValor]);
  return (
    <>
      <Grid item xs={12} sm={3}>
        <InputMonetario
          fullWidth
          id="baixa.juros.valor"
          label="Juros (R$)"
          onBlur={handleBlur}
          value={values?.baixa?.juros?.valor}
          handleChange={handleChange}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputMonetario
          fullWidth
          id="baixa.multa.valor"
          label="Multa (R$)"
          onBlur={handleBlur}
          value={values?.baixa?.multa?.valor}
          handleChange={handleChange}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputMonetario
          fullWidth
          id="baixa.desconto.valor"
          label="Desconto (R$)"
          onBlur={handleBlur}
          value={values?.baixa?.desconto?.valor}
          handleChange={handleChange}
          disabled={disabled}
        />
      </Grid>

      {/*
      RNE-087 - Cálculo do valor pago : Public <<Functional>> Feature
      Created:	19/03/2020 11:01:45
      Modified:	20/03/2020 11:29:03
      Project:	
      Advanced:	
      O "Valor pago" deve ser calculado conforme o cálculo abaixo:

      Valor pago = (Valor líquido + juros + multa) - descontos
      */}
      <Grid item xs={12} sm={3}>
        <ReadOnlyInput
          fullWidth
          id="valorPago"
          label="Valor pago (R$)"
          onBlur={handleBlur}
          value={getValorPago(values)}
          // error={!!_errors.valorUnitario}
          // helperText={_errors.valorUnitario || ''}
          handleChange={handleChange}
        />
      </Grid>
    </>
  );
};
export default ContasPagarAcrescimosDescontos;
